import React from 'react';

const AdvancedKubernetesServices = () => (
  <div className="py-16 bg-gradient-to-b from-gray-50 to-gray-100 min-h-screen">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-5xl md:text-6xl font-extrabold text-gray-800 mb-8" data-aos="fade-up">
          Advanced Kubernetes Services
        </h1>
        <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border-l-4 border-blue-600" data-aos="fade-up" data-aos-delay="100">
          <p className="text-lg text-gray-700 mb-6">
            Take your Kubernetes operations to the next level with our advanced services, including security, networking, and custom operator development. We help you design and implement robust, production-grade Kubernetes environments.
          </p>
          <ul className="list-disc ml-8 mb-6 text-gray-700">
            <li>Cluster security and RBAC policies</li>
            <li>Service mesh integration (Istio, Linkerd)</li>
            <li>Custom controller and operator development</li>
            <li>Multi-cluster management and scaling</li>
          </ul>
          <p className="text-gray-700">
            Contact us to enhance your Kubernetes capabilities.
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default AdvancedKubernetesServices;
